import { useCallback, useEffect, useState } from "react";
import { FirestoreService } from "../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../api/firebase/references";
import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";

export const useDraftSubmissionIsPresent = (
  orderId: string,
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const [draftSubmissionIsPresent, setDraftSubmissionIsPresent] =
    useState(false);

  const getDraftSubmission = useCallback(async () => {
    try {
      const draftSubmission = await FirestoreService.getAllDocuments(
        FirestoreCollectionReference.draftSubmission(orderId),
      );
      if (
        draftSubmission &&
        draftSubmission?.length &&
        draftSubmission?.length > 0
      ) {
        setDraftSubmissionIsPresent(true);
      } else {
        setDraftSubmissionIsPresent(false);
      }
    } catch (error) {
      console.error("Error fetching draft submission:", error);
      setDraftSubmissionIsPresent(false);
    }
  }, [orderId]);

  useEffect(() => {
    if (singleMedicalPaOrder) {
      getDraftSubmission();
    }
  }, [singleMedicalPaOrder, getDraftSubmission]);

  return draftSubmissionIsPresent;
};
